import React from 'react';
import { AdvertorialButton } from '../ui/AdvertorialButton';
export function HeroSection() {
  return <section id="home" className="relative w-full min-h-[420px] md:min-h-[500px] lg:min-h-[600px] flex items-center justify-center px-4 py-16 mt-[60px]" style={{
    backgroundImage: `linear-gradient(135deg, rgba(27, 79, 158, 0.75), rgba(45, 155, 110, 0.75)), url('https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1400&q=85')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-41">
      <div className="bg-white/95 rounded-lg shadow-xl max-w-[800px] w-full p-8 md:p-10 text-center" style={{
      boxShadow: '0px 8px 32px rgba(27, 79, 158, 0.15)'
    }} data-id="element-42">
        <h1 className="md:text-[38px] lg:text-[58px] font-bold mb-4 text-[30px]" style={{
        color: '#1B4F9E'
      }} data-id="element-43">
          What 15,000+ Australian Families Discovered About WiFi Exposure
        </h1>

        <p className="text-base md:text-lg lg:text-xl mb-6" style={{
        color: '#2C3E50'
      }} data-id="element-44">
          A research-backed guide to EMF exposure, sleep deprivation, and what
          actually works
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm" style={{
        color: '#2D9B6E'
      }} data-id="element-45">
          <span data-id="element-46">✓ Based on verified customer research</span>
          <span data-id="element-47">✓ Third-party tested</span>
          <span data-id="element-48">✓ Australian context</span>
        </div>
      </div>
    </section>;
}